import type { CertificationPeriodViewModel } from '@generated';
import { differenceInCalendarDays } from 'date-fns';

export function getDayOfStay(startOfCareDate: Date, asOf: Date) {
	return differenceInCalendarDays(asOf, startOfCareDate) + 2;
}

export function getCertificationPeriod(certificationPeriods: CertificationPeriodViewModel[], asOf: Date) {
	return (
		certificationPeriods.find(period => {
			return asOf >= period.startDate && asOf <= period.endDate;
		}) ?? null
	);
}
